import { MessageSquare, History, BarChart2, Trash2, Plus, GraduationCap } from "lucide-react";

export default function Sidebar({ aba, setAba, avaliacoes, onNova, onRemover }) {
  const media = avaliacoes.length
    ? (avaliacoes.reduce((s, a) => s + parseFloat(a.nota || 0), 0) / avaliacoes.length).toFixed(1)
    : null;

  return (
    <div style={{
      width: 260, background: "var(--sidebar)", display: "flex",
      flexDirection: "column", height: "100vh", flexShrink: 0
    }}>
      {/* Logo */}
      <div style={{ padding: "24px 20px 16px", borderBottom: "1px solid rgba(255,255,255,0.08)" }}>
        <div style={{ display: "flex", alignItems: "center", gap: 10, marginBottom: 4 }}>
          <div style={{
            width: 36, height: 36, borderRadius: 10, background: "var(--primary)",
            display: "flex", alignItems: "center", justifyContent: "center"
          }}>
            <GraduationCap size={20} color="#fff" />
          </div>
          <div>
            <div style={{ fontWeight: 700, fontSize: 15, color: "#fff" }}>PROBEX</div>
            <div style={{ fontSize: 11, color: "var(--sidebar-text)", opacity: 0.7 }}>Avaliador IA · UFPB</div>
          </div>
        </div>
      </div>

      {/* Stats rápidas */}
      {avaliacoes.length > 0 && (
        <div style={{ padding: "14px 16px", borderBottom: "1px solid rgba(255,255,255,0.08)" }}>
          <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 8 }}>
            <div style={{ background: "rgba(255,255,255,0.06)", borderRadius: 8, padding: "10px 12px" }}>
              <div style={{ fontSize: 11, color: "var(--sidebar-text)", opacity: 0.7, marginBottom: 2 }}>Avaliações</div>
              <div style={{ fontSize: 20, fontWeight: 700, color: "#fff" }}>{avaliacoes.length}</div>
            </div>
            <div style={{ background: "rgba(255,255,255,0.06)", borderRadius: 8, padding: "10px 12px" }}>
              <div style={{ fontSize: 11, color: "var(--sidebar-text)", opacity: 0.7, marginBottom: 2 }}>Média</div>
              <div style={{ fontSize: 20, fontWeight: 700, color: notaCor(parseFloat(media)) }}>{media}</div>
            </div>
          </div>
        </div>
      )}

      {/* Nav */}
      <nav style={{ padding: "12px 10px", flex: 1, overflowY: "auto" }}>
        <button onClick={onNova} style={{
          width: "100%", display: "flex", alignItems: "center", gap: 10,
          padding: "10px 12px", borderRadius: 8, border: "1px solid rgba(99,102,241,0.5)",
          background: "rgba(99,102,241,0.15)", color: "var(--sidebar-text2)",
          fontWeight: 500, fontSize: 13, marginBottom: 16, transition: "all .15s"
        }}>
          <Plus size={16} /> Nova avaliação
        </button>

        {[
          { id: "chat", icon: MessageSquare, label: "Avaliar projeto" },
          { id: "historico", icon: History, label: "Histórico" },
          { id: "stats", icon: BarChart2, label: "Estatísticas" },
        ].map(({ id, icon: Icon, label }) => (
          <button key={id} onClick={() => setAba(id)} style={{
            width: "100%", display: "flex", alignItems: "center", gap: 10,
            padding: "10px 12px", borderRadius: 8, border: "none",
            background: aba === id ? "rgba(99,102,241,0.2)" : "transparent",
            color: aba === id ? "#fff" : "var(--sidebar-text)",
            fontWeight: aba === id ? 500 : 400, fontSize: 13,
            marginBottom: 2, transition: "all .15s"
          }}>
            <Icon size={16} />
            {label}
          </button>
        ))}

        {/* Histórico recente */}
        {avaliacoes.length > 0 && (
          <div style={{ marginTop: 20 }}>
            <div style={{ fontSize: 11, fontWeight: 600, color: "var(--sidebar-text)", opacity: 0.5, padding: "0 12px", marginBottom: 6, textTransform: "uppercase", letterSpacing: "0.05em" }}>
              Recentes
            </div>
            {avaliacoes.slice(0, 6).map(a => (
              <div key={a.id} style={{
                display: "flex", alignItems: "center", gap: 8,
                padding: "8px 12px", borderRadius: 8, marginBottom: 1,
                cursor: "pointer", transition: "background .15s"
              }}
                onMouseEnter={e => e.currentTarget.style.background = "rgba(255,255,255,0.05)"}
                onMouseLeave={e => e.currentTarget.style.background = "transparent"}
                onClick={() => setAba("historico")}
              >
                <div style={{
                  width: 28, height: 28, borderRadius: 6, flexShrink: 0,
                  background: notaBg(parseFloat(a.nota)),
                  display: "flex", alignItems: "center", justifyContent: "center",
                  fontSize: 11, fontWeight: 700, color: notaCor(parseFloat(a.nota))
                }}>{a.nota}</div>
                <div style={{ overflow: "hidden" }}>
                  <div style={{ fontSize: 12, color: "var(--sidebar-text)", fontWeight: 500, whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" }}>
                    {a.titulo || "Sem título"}
                  </div>
                  <div style={{ fontSize: 11, color: "var(--sidebar-text)", opacity: 0.5 }}>
                    {new Date(a.data).toLocaleDateString("pt-BR")}
                  </div>
                </div>
                <button onClick={e => { e.stopPropagation(); onRemover(a.id); }} style={{
                  marginLeft: "auto", background: "none", border: "none", color: "var(--sidebar-text)",
                  opacity: 0, padding: 2, display: "flex", borderRadius: 4
                }}
                  onMouseEnter={e => { e.currentTarget.style.opacity = "0.6"; e.currentTarget.style.color = "#ef4444"; }}
                  onMouseLeave={e => { e.currentTarget.style.opacity = "0"; }}
                >
                  <Trash2 size={13} />
                </button>
              </div>
            ))}
          </div>
        )}
      </nav>

      <div style={{ padding: "12px 16px", borderTop: "1px solid rgba(255,255,255,0.08)" }}>
        <div style={{ fontSize: 11, color: "var(--sidebar-text)", opacity: 0.4, textAlign: "center" }}>
          IA local · dados privados · UFPB
        </div>
      </div>
    </div>
  );
}

function notaCor(n) {
  if (!n) return "#94a3b8";
  return n >= 8 ? "#10b981" : n >= 6 ? "#f59e0b" : "#ef4444";
}
function notaBg(n) {
  if (!n) return "#f1f5f9";
  return n >= 8 ? "#d1fae5" : n >= 6 ? "#fef3c7" : "#fee2e2";
}
